import type { Step } from './types';

export const getNextIndex = (steps: Step[], selectedStep: Step) => {
  const index = steps.findIndex((item) => item.id === selectedStep.id);
  const nextIndex = (index + 1) % steps.length === 0 ? 0 : index + 1;

  return nextIndex;
};
